import { getCookie } from "../utils/utils";

export default class Cookies {
	constructor() {
		this.banner = document.querySelector('.cookie-consent-banner');
		this.rejectButton = document.querySelector('.button--reject');
		this.acceptButton = document.querySelectorAll('.button--accept');
		this.learnMoreButton = document.querySelector('.button--learn-more');

		// CLIENT DETAILS
		// this.tagManagerId = 'GTM-52NTWD';
		this.ga4Id = 'G-CB8LWW8V11';

		// Add new property for body element
		this.body = document.body;

		this.init();
	}

	init() {
		// Add show banner call at the start if no consent cookie exists
		const consentCookie = getCookie('consent');
		if(!consentCookie) {
			this.showBanner();
		}

		// Show detailed view when clicking "Learn More"
		this.learnMoreButton.addEventListener('click', () => {
			this.banner.classList.add('cookie-consent-banner--expanded');
		});

		// Handle Accept clicks
		this.acceptButton.forEach(button => {
			button.addEventListener('click', () => {
				this.setCookie('consent', 'accepted', 30);
				this.hideBanner();
				this.enableScroll();
				this.injectAnalytics();
			});
		});

		// Handle Reject click
		this.rejectButton?.addEventListener('click', () => {
			this.setCookie('consent', 'rejected', 30);
			this.hideBanner();
			this.enableScroll();
		});

		// Check if consent cookie exists and handle analytics on page load
		if(consentCookie) {
			this.hideBanner();
			this.enableScroll();
			if(consentCookie === 'accepted') {
				this.injectAnalytics();
			}
		}
	}

	setCookie(name, value, days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = "; expires=" + date.toUTCString();
		document.cookie = name + "=" + value + expires + "; path=/";
	}

	hideBanner() {
		this.banner.classList.add('cookie-consent-banner--close');
	}

	injectAnalytics() {
		// Check if we're in a development environment
		const isDevelopment = window.location.hostname === 'localhost' 
			|| window.location.hostname === '127.0.0.1'
			|| window.location.port.match(/^(3000|8080|8000)$/)
			|| window.location.hostname.includes('.local')
			|| window.location.hostname.includes('.test');

		// Don't inject analytics if we're in development
		if (isDevelopment) {
			console.log('Analytics not injected in development environment');
			return;
		}

		// GTM Script
		if(this.tagManagerId) {
			const gtmScript = document.createElement('script');
			gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','${this.tagManagerId}');`;
			document.head.appendChild(gtmScript);
			// GTM noscript iframe
			const gtmNoscript = document.createElement('noscript');
			gtmNoscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${this.tagManagerId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
			document.body.insertBefore(gtmNoscript, document.body.firstChild);
		}

		// GA4 Script
		if(this.ga4Id) {
			const gaScriptLoader = document.createElement('script');
			gaScriptLoader.async = true;
			gaScriptLoader.src = `https://www.googletagmanager.com/gtag/js?id=${this.ga4Id}`;
			const gaScript = document.createElement('script');
			gaScript.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${this.ga4Id}');
			`;
		
			document.head.appendChild(gaScriptLoader);
			document.head.appendChild(gaScript);
		}

	}

	// Add new methods
	showBanner() {
		this.banner.classList.remove('hidden');
		this.disableScroll();
	}

	disableScroll() {
		this.body.classList.add('no-scroll');
		if( window.app.smoothScroll.lenis ){
			window.app.smoothScroll.lenis.stop();
		}
	}

	enableScroll() {
		this.body.classList.remove('no-scroll');
		if( window.app.smoothScroll.lenis ){
			window.app.smoothScroll.lenis.start();
		}
	}
}